// extracted by mini-css-extract-plugin
module.exports = {"activitiesLoading":"LoadingActivitiesList_activitiesLoading___8g_v"};